import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { EngageCtaPopup } from './engage-cta-popup';
import { useOnAfterRouteChange } from '../../../infra/routing';
import { isEngageCtaNeeded, isEngageCtaShownForPathname } from './utils';
import { useApiQuery } from '../../../infra/api';
import { getSessionShop, getViewerIdAndKind, useSession } from '../../../infra/session';
import { endpoints as campaignEndpoints } from '../network';
import { useCanUserSeeEngage } from '../engage-access-utils';
import { useProductivity } from './use-productivity-stats';
import { didEnoughTimePass, setLastInteractionDate } from '../../../infra/persistence/interactionStateUtils';
var DISMISSED_KEY = 'squire_engageCtaDismissed';
var SHOW_AGAIN_HOURS_THRESHOLD = 24;
export var EngageCtaContainer = function () {
    var _a = useState(isEngageCtaShownForPathname(window.location.pathname)), isPathnameAllowed = _a[0], setIsPathnameAllowed = _a[1];
    useOnAfterRouteChange(function (nextRoute) {
        setIsPathnameAllowed(isEngageCtaShownForPathname(nextRoute.pathname));
    }, []);
    var _b = useState(!didEnoughTimePass(DISMISSED_KEY, SHOW_AGAIN_HOURS_THRESHOLD)), wasDismissedInLastDay = _b[0], setWasDismissedInLastDay = _b[1];
    var handleDismiss = function () {
        setLastInteractionDate(DISMISSED_KEY);
        setWasDismissedInLastDay(true);
    };
    var session = useSession().data;
    var shop = getSessionShop(session);
    var viewerIdAndKind = getViewerIdAndKind(session);
    var canSeeEngage = useCanUserSeeEngage();
    var productivity = useProductivity(canSeeEngage);
    var campaigns = useApiQuery({
        endpoint: campaignEndpoints.campaignsQuery,
        payload: {
            ownerType: viewerIdAndKind.kind,
            ownerId: viewerIdAndKind.id,
            perPage: 1,
            page: 1,
        },
        options: {
            enabled: !!viewerIdAndKind && canSeeEngage,
        },
    }).data;
    var shouldShowCta = isPathnameAllowed &&
        canSeeEngage &&
        !wasDismissedInLastDay &&
        isEngageCtaNeeded(productivity, campaigns === null || campaigns === void 0 ? void 0 : campaigns.list, shop === null || shop === void 0 ? void 0 : shop.timezone);
    if (!shouldShowCta) {
        return null;
    }
    return _jsx(EngageCtaPopup, { onClose: handleDismiss });
};
